"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var d3_dsv_1 = require("d3-dsv");

var data_types_1 = require("./data_types");

function parseHints(hints) {
  var items = hints.match(/ *\*(.*)/);

  if (items) {
    var entries = items[1].trim().split(";").map(function (x) {
      return x.trim();
    }).filter(function (x) {
      return x != "";
    });
    var result = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var entry = _step.value;

        var _items = entry.split(":").map(function (x) {
          return x.trim();
        });

        if (_items.length == 2) {
          result[_items[0]] = _items[1];
        } else if (_items.length == 1) {
          result[_items[0]] = "true";
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return result;
  } else {
    return {};
  }
}

exports.parseHints = parseHints;

function parseDataset(fileName, content, type) {
  var rows;

  switch (type) {
    case "csv":
      {
        rows = d3_dsv_1.csvParseRows(content);
      }
      break;

    case "tsv":
      {
        rows = d3_dsv_1.tsvParseRows(content);
      }
      break;

    default:
      {
        rows = [[]];
      }
      break;
  } // Remove empty rows if any


  rows = rows.filter(function (row) {
    return row.length > 0;
  });

  if (rows.length > 0) {
    var header = rows[0];
    var columnHints;
    var data = rows.slice(1);

    if (data.length > 0 && data[0].every(function (x) {
      return /^ *\*/.test(x);
    })) {
      columnHints = data[0].map(parseHints);
      data = data.slice(1);
    } else {
      columnHints = header.map(function (x) {
        return {};
      });
    }

    var columnValues = header.map(function (name, index) {
      var values = data.map(function (row) {
        return row[index];
      });
      return data_types_1.inferAndConvertColumn(values);
    });
    var outRows = data.map(function (row, rindex) {
      var out = {
        _id: rindex.toString()
      };
      columnValues.forEach(function (column, cindex) {
        out[header[cindex]] = columnValues[cindex].values[rindex];
      });
      return out;
    });
    var columns = columnValues.map(function (x, i) {
      return {
        name: header[i],
        type: x.type,
        metadata: x.metadata
      };
    });
    return {
      name: fileName,
      displayName: fileName,
      columns: columns,
      rows: outRows
    };
  } else {
    return null;
  }
}

exports.parseDataset = parseDataset;